import { americanToDecimal } from '@/utils/odds'

const WORD_INITIAL_PATTERN = /\b\w/g

export const BOOST_KIND_LABELS = {
  payout_boost: 'Payout Boost',
  points_boost: 'Points Boost',
}

export function boostKindLabel(kind) {
  return BOOST_KIND_LABELS[kind] || String(kind || 'Boost').replaceAll('_', ' ').replace(WORD_INITIAL_PATTERN, (c) => c.toUpperCase())
}

/** Percentage payout lift from base to boosted American odds; null when either price is unreadable. */
export function boostLiftPercent(baseOdds, boostedOdds) {
  const base = americanToDecimal(baseOdds)
  const boosted = americanToDecimal(boostedOdds)
  if (base == null || boosted == null || base <= 1) return null
  return Math.round(((boosted - 1) / (base - 1) - 1) * 100)
}

/** "2h 15m left", "12m left" or "Expired". */
export function boostCountdown(expiresAt, now = Date.now()) {
  const expires = Date.parse(expiresAt)
  if (!Number.isFinite(expires)) return ''
  const minutes = Math.round((expires - now) / 60_000)
  if (minutes <= 0) return 'Expired'
  if (minutes < 60) return `${minutes}m left`
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m left`
}

/** "just now", "3m ago", "2h ago". */
export function syncedLabel(syncedAt, now = Date.now()) {
  const synced = Date.parse(syncedAt)
  if (!Number.isFinite(synced)) return ''
  const minutes = Math.round((now - synced) / 60_000)
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes}m ago`
  return `${Math.floor(minutes / 60)}h ago`
}

export function normalizeBoost(raw) {
  return {
    id: raw?.id || `${raw?.selection}-${raw?.expires_at}`,
    kind: raw?.kind || 'payout_boost',
    selection: raw?.selection || 'Boost',
    detail: raw?.detail || '',
    sport: raw?.sport || '',
    league: raw?.league || '',
    event: raw?.event || '',
    baseOdds: raw?.base_odds || '',
    boostedOdds: raw?.boosted_odds || '',
    expiresAt: raw?.expires_at || null,
    surfaces: Array.isArray(raw?.surfaces) ? raw.surfaces.filter((s) => s?.surface) : [],
  }
}
